import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { ProductToPay } from '../../../sections/Payment/types'

export const isProductProtected = (product?: IProduct | ProductToPay) =>
  product?.youthProtectionValue === '1' || product?.youthProtectionValue === '2'

export const isProductHighlyProtected = (product?: IProduct | ProductToPay) =>
  product?.youthProtectionValue === '2'
